import moment from 'moment'
import {decodeId} from "@/lib/string";
import { formatDateTime } from "@/lib/fancy_date";

const filters = {

    humanizeSeconds: (value) => {
        if (!value) return '';
        let duration  = moment.duration(parseInt(value), "seconds");
        let h = duration.hours();
        let m = duration.minutes();
        let s = duration.seconds();
        let timeString = m.toString() + "m " + s.toString() + "s ";
        if (h > 0)
            timeString = h.toString() + "h " + timeString;

        return timeString;
    },

    decodeId: (value) => decodeId(value),
    readableDateTime: (value) => formatDateTime(value, "ddd, D MMM YYYY h.mm A", false),
    readableDateTimeWithDaysAgo: (value) => formatDateTime(value, "ddd, D MMM YYYY h.mm A", true),
    readableSubscriptionType: (value) => {
        if (!value) return "";
        return {
            "ONE_ON_ONE": "One-On-One",
            "JEFF_MEMBER": "JEFF Life",
            "CLUB": "Club"
        }[value]
    }
};
export default filters